import React, { memo } from 'react'
import { Card } from 'antd'
import PropTypes from 'prop-types'

import './DataCard.scss'

function DataCard({ children, onClick = () => {} }) {
  return (
    <Card hoverable className="data-card" onClick={onClick}>
      {children}
    </Card>
  )
}

export default memo(DataCard)

DataCard.propTypes = {
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func
}
